import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { Input } from "ui-kit/PrimitiveControls/Input";
import Plus from '../../assets/plusWhite.svg'
import Arrow from '../../assets/ArrowBottom.svg'
import { useArtists } from "components/NewRelease/hooks/useArtists";
import Shiotify from '../../assets/shiotify.svg'
import Apple from '../../assets/apple.svg'
import Line from '../../assets/line.svg'
import Youtube from '../../assets/youtube.svg'
import Edit from '../../assets/edit.svg'
import Trash from '../../assets/trash.svg'
import Copy from '../../assets/copy.svg'
import Instagram from '../../assets/instagram.svg'
import Vkontakte from '../../assets/vkontakte.svg'
import { useNavigate } from "react-router";
import { Paginator, PaginatorPageChangeEvent } from "primereact/paginator";
import { ProgressSpinner } from "primereact/progressspinner";
import { AddArtistModal } from "./AddArtistModal";
import Search from '../../assets/search.svg'
import Facebook from '../../assets/facebook.svg'
import {
  Container,
  AddBox,
  HeadBox,
  TabeBox,
  Title,
  AppleBox,
  Social,
  Channel,
  Content,
  Row,
  Name,
  AppleSpotify,
  AppleSpotifyBox,
  SocialBox,
  YoutubeBox,
  EditBox,
  Box,
  Dropdown,
  ModalOverlay,
  Modal,
  TextBox,
  ButtonBox,
  NoBox,
  YesBox,
  PaginatorWrapper,
  LoadingBox,
  Loading,
  SearchInputWrapper,
  SearchIcon,
  ScrollableList,
  PaginatorBar,
} from './styles/ArtistListStyles';
import IntlStore from "stories/IntlStore";
import {FormattedMessage} from "react-intl";


export const Artists = () => {
  const [search, setSearch] = useState<string>('');
  const [value, setValue] = useState<string>('');
  const [showModal, setShowModal] = useState('');
  const [first, setFirst] = useState<number>(0);
  const [selectedStatus, setSelectedStatus] = useState<string>('1');
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageCount, setPageCount] = useState<number>(10);
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  const [isOpenArtistsModal, setIsOpenArtistsModal] = useState(false);
  const [delError, setDelError] = useState('')
  const [isMobile, setIsMobile] = useState<boolean>(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia("(max-width: 768px)").matches;
  });

  const handleDeleteClick = (id: string) => {
    setShowModal(id);
  };

  const handleClose = () => {
    setShowModal('');
  };

  const navigate = useNavigate()
  const { artists, total, fetching, removeArtist, createArtist, creating: artistCreating } = useArtists(
    selectedStatus,
    currentPage,
    pageCount,
    search,
  );

  const [loading, setLoading] = useState(fetching);

  const onPageChange = (event: PaginatorPageChangeEvent) => {
    setCurrentPage(event.page + 1);
    setFirst(event.rows * event.page);
    setPageCount(event.rows);
  };
  useEffect(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(() => {
      setSearch(value);
    }, 500);
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [value]);

  useEffect(() => {
    setLoading(fetching)
  }, [fetching])

  useEffect(() => {
    if (typeof window === "undefined") return;
    const mql = window.matchMedia("(max-width: 768px)");
    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    setIsMobile(mql.matches);
    // Safari < 14
    if ((mql as any).addEventListener) {
      mql.addEventListener("change", onChange);
      return () => mql.removeEventListener("change", onChange);
    }
    (mql as any).addListener?.(onChange);
    return () => (mql as any).removeListener?.(onChange);
  }, []);

  const goToFirstPage = () => {
    const event = {
      first: 0,
      rows: pageCount,
      page: 0,
      pageCount: Math.ceil(total / pageCount),
    };
    onPageChange(event);
  };

  return (
    <Container>
      <HeadBox>
      <SearchInputWrapper>
      <SearchIcon><Search/></SearchIcon>
        <SearchInput
          name="search"
          value={value}
          onChange={(event) => setValue(event.target.value)}
          placeholder={IntlStore.intl.formatMessage({
            id: "Artists.SearchArtistsPlaceholder",
            defaultMessage: "Search by artists"
          })}
        />
        </SearchInputWrapper>
        <AddBox onClick={() => setIsOpenArtistsModal(true)}>
          <Plus /> <span style={{ cursor: 'pointer' }}>
          <FormattedMessage
            id="Authors.CreateArtist"
            defaultMessage="Create artist"
          />
        </span>
        </AddBox>
      </HeadBox>
      <ScrollableList>
        <Content>
          <TabeBox>
            <Title>
              <FormattedMessage
                id="Authors.Artist"
                defaultMessage="Artist"
              />
              <Arrow /></Title>
            <AppleBox>
              <FormattedMessage
                id="Authors.AppleSpotify"
                defaultMessage="Apple/Spotify"
              />
            </AppleBox>
            <Social>
              <FormattedMessage
                id="Authors.SocialNetworks"
                defaultMessage="Social networks"
              />
            </Social>
            <Channel>
              <FormattedMessage
                id="Authors.Channel"
                defaultMessage="Youtube Official Artist Channel [OAC]"
              />
            </Channel>
          </TabeBox>
          {loading ? (<LoadingBox>
            <Loading>
              <ProgressSpinner />
            </Loading>
          </LoadingBox>) : artists.map((artist) => (
            <Row key={artist.id} >
              <Name>{artist.name}</Name>
              <AppleSpotify>
                {!artist.platforms.some((p) => p.url) ? (
                  <Line />
                ) : (
                  artist.platforms.map((platform) => (
                    <AppleSpotifyBox key={platform.id}>
                      <Box>
                        <Dropdown className="dropdown">
                          <span>
                            <FormattedMessage
                              id="Authors.SpotifyMusic"
                              defaultMessage="Spotify Music"
                            />
                          </span>
                          <span
                            onClick={() =>
                              navigator.clipboard.writeText(platform.url ?? '')
                            }
                          >
                            <Copy />
                          </span>
                        </Dropdown>
                        {platform.name === 'Spotify' && platform.url && <Shiotify />}
                      </Box>

                      <Box>
                        <Dropdown className="dropdown">
                          <span>
                            <FormattedMessage
                              id="Authors.AppleMusic"
                              defaultMessage="Apple Music"
                            />
                          </span>
                          <span
                            onClick={() =>
                              navigator.clipboard.writeText(platform.url ?? '')
                            }
                          >
                            <Copy />
                          </span>
                        </Dropdown>
                        {platform.name === 'Apple Music' && platform.url && <Apple />}
                      </Box>
                    </AppleSpotifyBox>
                  ))
                )}
              </AppleSpotify>
              <SocialBox>
                {artist?.networks.slice(-5).map((network) => (
                  <AppleSpotifyBox key={network.id}>
                    <Box>
                      <Dropdown className="dropdown"><span>Instagram</span> <span onClick={() => navigator.clipboard.writeText(network.link ?? '')}><Copy /></span></Dropdown>
                      {network.title === "instagram"|| network.link.includes("instagram.com") && <Instagram />}
                    </Box>
                    <Box>
                      <Dropdown className="dropdown"><span>Facebook</span> <span onClick={() => navigator.clipboard.writeText(network.link ?? '')}><Copy /></span></Dropdown>
                      { network.link.includes("facebook.com") && <Facebook />}
                    </Box>
                    <Box>
                      <Dropdown className="dropdown"><span>Vkontakte</span><span onClick={() => navigator.clipboard.writeText(network.link ?? '')}><Copy /></span></Dropdown>
                      {network.title === "Vk" && <Vkontakte />}
                    </Box>
                  </AppleSpotifyBox>
                ))}
                <AppleSpotifyBox >
                  {Array.isArray(artist?.networks) && artist.networks.length === 0 && <Line />}
                </AppleSpotifyBox>
              </SocialBox>
              <YoutubeBox>
                <Box>
                  {artist.youtube_id && <Dropdown className="dropdown"><span>Youtube</span> <span onClick={() => navigator.clipboard.writeText(artist.youtube_id ?? '')}><Copy /></span></Dropdown>}                {artist.youtube_id ? <Youtube /> : <Line />}</Box>

              </YoutubeBox>
              <EditBox>
                <div onClick={() => { navigate(`/artists/${artist.id}`) }} >
                  <Edit />
                </div>
                <div onClick={() => handleDeleteClick(artist.id)}>
                  <Trash />
                </div>
              </EditBox>
            </Row>
          ))}
        </Content>
      </ScrollableList>

      {showModal && (
        <ModalOverlay>
          <Modal>
            {delError ? <TextBox><span>
                <FormattedMessage
                  id="Artists.ModalTitle1"
                  defaultMessage="Artist can’t be deleted while active releases remain."
                />
            </span><span>
                <FormattedMessage
                  id="Artists.ModalText1"
                  defaultMessage="Please remove or deactivate all"
                />
            </span><span>
                <FormattedMessage
                  id="Artists.ModalText2"
                  defaultMessage=" releases before trying again"
                />
            </span></TextBox> :
              <TextBox>
                <FormattedMessage
                  id="Artists.ModalText3"
                  defaultMessage="Are you sure you want to delete the artist?"
                />
              </TextBox>}
            <ButtonBox>
              {!delError && <NoBox onClick={handleClose}>
                <FormattedMessage
                  id="Artists.No"
                  defaultMessage="No"
                />
              </NoBox>}
              <YesBox
                onClick={() => {
                  if (delError) {
                    setDelError('');
                    setShowModal('');
                    return;
                  }
                  removeArtist(showModal)
                    .then(() => {
                      setShowModal('');
                      navigate('/artists');
                    })
                    .catch((error) => {
                      setDelError(error.message || 'Something went wrong');
                    });
                }}
              >
                {delError ? (
                  <FormattedMessage
                    id="Artists.Ok"
                    defaultMessage="Ok"
                  />
                ) : (
                  <FormattedMessage
                    id="Artists.Yes"
                    defaultMessage="Yes"
                  />
                )}
              </YesBox>

            </ButtonBox>
          </Modal>
        </ModalOverlay>
      )}
      {!!onPageChange && (
        <PaginatorBar>
          <PaginatorWrapper>
            <Paginator
              first={first}
              rows={pageCount}
              totalRecords={total}
              rowsPerPageOptions={[5, 10, 20, 30]}
              onPageChange={onPageChange}
              pageLinkSize={isMobile ? 1 : 5}
              template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            />
          </PaginatorWrapper>
        </PaginatorBar>
      )}
      <AddArtistModal
        goToFirstPage={goToFirstPage}
        isOpen={isOpenArtistsModal}
        onHide={() => setIsOpenArtistsModal(false)}
        artists={artists}
        createArtist={createArtist}
        artistCreating={artistCreating}
      />


    </Container>
  );
};


const SearchInput = styled(Input)`
  height: 43px;
  width: 100%;
  overflow: hidden;
  padding-left: 32px;
  border: none;
  background: transparent;
  outline: none;  
  &:focus {
    border: none;
    outline: none;  
    box-shadow: none;
  }
  &:active {
    border: none;
    outline: none;  
    box-shadow: none;
  }
`;

